export class RelTalhoesFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getTalhoesProducao(filter) {
    return this.instance.post(
      '/v1/relatorios/talhoes/producao-por-talhao',
      filter,
    );
  }

  getRelTalhoesIndiretos(filter) {
    return this.instance.get(`/v1/relatorios/talhoes/indiretos`, {
      params: filter || null,
    });
  }
}

export default RelTalhoesFactory;
